// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"181":"00bac3d3","535":"b982ae77"}[chunkId] + ".chunk.css";
};